import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { invoicesMainRoute } from 'features/procurement/finance';

import { invoiceDetailsRouteSearchSchema } from './types';

export const invoiceDetailsRoute = createRoute({
  getParentRoute: () => invoicesMainRoute,
  path: '/$invoiceId',
  component: lazyRouteComponent(
    () => import('../../../invoices/InvoiceDetailsView/InvoiceDetailsView'),
  ),
  validateSearch: invoiceDetailsRouteSearchSchema.parse,
  parseParams: (params) => ({
    invoiceId: z.string().parse(params.invoiceId),
  }),
});
